import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright 2017-2021 @polkadot/ui-keyring authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert } from '@polkadot/util';
import { BehaviorSubject } from '@polkadot/x-rxjs';
import { obervableAll } from "../observable/index.mjs";
var hasCalledInitOptions = false;

var sortByName = function sortByName(a, b) {
  var valueA = a.option.name;
  var valueB = b.option.name;
  return valueA.localeCompare(valueB);
};

var sortByCreated = function sortByCreated(a, b) {
  var valueA = a.json.meta.whenCreated || 0;
  var valueB = b.json.meta.whenCreated || 0;

  if (valueA < valueB) {
    return 1;
  }

  if (valueA > valueB) {
    return -1;
  }

  return 0;
};

export var KeyringOption =
/*#__PURE__*/
function () {
  function KeyringOption() {
    _classCallCheck(this, KeyringOption);

    this.optionsSubject = new BehaviorSubject(this.emptyOptions());
  }

  _createClass(KeyringOption, [{
    key: "createOptionHeader",
    value: function createOptionHeader(name) {
      return {
        key: "header-".concat(name.toLowerCase()),
        name: name,
        value: null
      };
    }
  }, {
    key: "init",
    value: function init(keyring) {
      var _this = this;

      assert(!hasCalledInitOptions, 'Unable to initialise options more than once');
      obervableAll.subscribe(function () {
        var opts = _this.emptyOptions();

        _this.addAccounts(keyring, opts);

        _this.addAddresses(keyring, opts);

        _this.addContracts(keyring, opts);

        opts.address = _this.linkItems({
          Addresses: opts.address,
          Recent: opts.recent
        });
        opts.account = _this.linkItems({
          Accounts: opts.account,
          Development: opts.testing
        });
        opts.contract = _this.linkItems({
          Contracts: opts.contract
        });
        opts.all = [].concat(opts.account, opts.address);
        opts.allPlus = [].concat(opts.account, opts.address, opts.contract);

        _this.optionsSubject.next(opts);
      });
      hasCalledInitOptions = true;
    }
  }, {
    key: "linkItems",
    value: function linkItems(items) {
      var _this2 = this;

      return Object.keys(items).reduce(function (result, header) {
        var options = items[header];
        return result.concat(options.length ? [_this2.createOptionHeader(header)] : [], options);
      }, []);
    }
  }, {
    key: "addAccounts",
    value: function addAccounts(keyring, options) {
      var available = keyring.accounts.subject.getValue();
      Object.values(available).sort(sortByName).forEach(function (_ref) {
        var _ref$json$meta$isTest = _ref.json.meta.isTesting,
            isTesting = _ref$json$meta$isTest === void 0 ? false : _ref$json$meta$isTest,
            option = _ref.option;

        if (!isTesting) {
          options.account.push(option);
        } else {
          options.testing.push(option);
        }
      });
    }
  }, {
    key: "addAddresses",
    value: function addAddresses(keyring, options) {
      var available = keyring.addresses.subject.getValue();
      Object.values(available).filter(function (_ref2) {
        var json = _ref2.json;
        return !!json.meta.isRecent;
      }).sort(sortByCreated).forEach(function (_ref3) {
        var option = _ref3.option;
        options.recent.push(option);
      });
      Object.values(available).filter(function (_ref4) {
        var json = _ref4.json;
        return !json.meta.isRecent;
      }).sort(sortByName).forEach(function (_ref5) {
        var option = _ref5.option;
        options.address.push(option);
      });
    }
  }, {
    key: "addContracts",
    value: function addContracts(keyring, options) {
      var available = keyring.contracts.subject.getValue();
      Object.values(available).sort(sortByName).forEach(function (_ref6) {
        var option = _ref6.option;
        options.contract.push(option);
      });
    }
  }, {
    key: "emptyOptions",
    value: function emptyOptions() {
      return {
        account: [],
        address: [],
        all: [],
        allPlus: [],
        contract: [],
        recent: [],
        testing: []
      };
    }
  }]);

  return KeyringOption;
}();